"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voteRecordAddress = void 0;
const utf8_1 = require("@coral-xyz/anchor/dist/cjs/utils/bytes/utf8");
const web3_js_1 = require("@solana/web3.js");
const sdk_1 = require("./sdk");
function voteRecordAddress({ directedStakeProgramId = new web3_js_1.PublicKey(sdk_1.DEFAULT_DIRECTED_STAKE_PROGRAM_ID), root, owner, }) {
    const [address, bump] = web3_js_1.PublicKey.findProgramAddressSync([(0, utf8_1.encode)(sdk_1.DIRECTED_STAKE_SEED), root.toBytes(), owner.toBytes()], directedStakeProgramId);
    return { address, bump };
}
exports.voteRecordAddress = voteRecordAddress;
//# sourceMappingURL=accounts.js.map